import { getStatus } from '../helpers';

import { IPortfolioDiversificationInputs } from './interfaces';
import { IV1, IV2, IV3A, IV3B } from './rules';

const rules = [IV1, IV2, IV3A, IV3B];

export const getPortfolioDiversificationStatus = (inputs: IPortfolioDiversificationInputs) =>
  getStatus<IPortfolioDiversificationInputs>(inputs, rules);
